const extractAttributeValue = (text, attribute) => {
  if (!text) return undefined;
  const lookingFor = `${attribute}="`;
  const from = text.indexOf(lookingFor) + lookingFor.length;
  const to = text.indexOf('"', from);
  return text.substring(from, to);
};

export const getNS = (text) => extractAttributeValue(text, 'xmlns:app');
// http://skjema.geonorge.no/SOSI/produktspesifikasjon/Kommuneplan/20190401
// http://skjema.geonorge.no/SOSI/produktspesifikasjon/Reguleringsplan/20190401

export const getSrsName = (text) => extractAttributeValue(text, 'srsName');
// 'urn:ogc:def:crs:EPSG::25832'

export const removeSymbols = (text) => {
  // Clean sosi from symbols, otherwise sosi parser will not work:
  const lines = text.split('\n');
  const ll = lines.length;
  let excluding = false;
  const textWithoutSymbols = [];
  for (let i = 0; i < ll; i++) {
    const line = lines[i];
    if (excluding) {
      // line.endsWith(':') does not verify when CR at the end
      if (
        line.startsWith('.K') || line.startsWith('.T') ||
        line.startsWith('.B') || line.startsWith('.SLUTT')
      ) {
        excluding = false;
        textWithoutSymbols.push(line);
      } // else console.log('Excluding:', line);
    } else {
      if (line.startsWith('.SYMBOL')) {
        excluding = true;
        // console.log('Excluding:', line);
      } else textWithoutSymbols.push(line);
    }
  }
  // console.log('#lines', ll, '-->', textWithoutSymbols.length);
  return textWithoutSymbols.join('\n');
};

